import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-split-vendas',
  template: `
  <router-outlet></router-outlet>
`,
})
export class SplitVendasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
